import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import DialogoConfirmacion from '../../DialogoConfirmacion';
import { Box } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import PersonIcon from '@material-ui/icons/Person';
import { UsersService } from '../../../api/users.services';
import Snackbar from '@material-ui/core/Snackbar';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { useSelector } from 'react-redux';

export default function UserDialog({ open, onClose, user, onSave, onDelete }) {
	const [formData, setFormData] = useState({
		id: '',
		user: '',
		email: '',
		equipo: 'PERFUMERIA',
		admin: false,
	});
	const [newPassword, setNewPassword] = useState(null);
	const [openSnackbar, setOpenSnackbar] = useState(false);
	const [copySuccess, setCopySuccess] = useState(false);
	const [errors, setErrors] = useState({
		email: '',
		user: '',
	});
	const currentUserConnection = useSelector((state) => state.User);

	useEffect(() => {
		if (user) {
			setFormData({
				id: user.id,
				user: user.user,
				email: user.email,
				equipo: user.equipo,
				admin: Boolean(user.admin),
			});
		} else {
			const currentUserEquipo = currentUserConnection.user.equipo;
			setFormData({
				id: '',
				user: '',
				email: '',
				equipo: currentUserEquipo,
				admin: false,
			});
		}
		// Resetear errores cuando se abre el diálogo
		setErrors({
			email: '',
			user: '',
		});
	}, [user, currentUserConnection]);

	const validateEmail = async (email) => {
		if (!email) {
			return 'El email es requerido';
		}

		if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
			return 'El formato del email no es válido';
		}

		try {
			const users = await UsersService.getUsersService();
			const isDuplicate = users.some(
				(u) =>
					u.email.toLowerCase() === email.toLowerCase() && u.id !== formData.id
			);

			if (isDuplicate) {
				return 'Este email ya está en uso por otro usuario';
			}
		} catch (error) {
			console.error('Error al validar email:', error);
			return 'Error al validar el email';
		}

		return '';
	};

	const handleChange = async (e) => {
		const { name, value } = e.target;
		setFormData({
			...formData,
			[name]: value,
		});

		// Validar email en tiempo real
		if (name === 'email') {
			const error = await validateEmail(value);
			setErrors({
				...errors,
				email: error,
			});
		}
	};

	const handleCheckboxChange = (e) => {
		setFormData({
			...formData,
			[e.target.name]: e.target.checked,
		});
	};

	const handleSubmit = async () => {
		// Validar email antes de guardar
		const emailError = await validateEmail(formData.email);
		if (emailError) {
			setErrors({
				...errors,
				email: emailError,
			});
			return;
		}

		onSave(formData, handleResetPassword);
	};

	const handleResetPassword = async (id) => {
		try {
			const password = await UsersService.resetPasswordService(id);
			if (password) {
				setNewPassword(password);
				setOpenSnackbar(true);
			}
		} catch (error) {
			console.error('Error al resetear password:', error);
		}
	};

	const handleCloseSnackbar = () => {
		setOpenSnackbar(false);
	};

	const copyToClipboard = () => {
		navigator.clipboard
			.writeText(newPassword)
			.then(() => {
				setCopySuccess(true);
				setTimeout(() => setCopySuccess(false), 2000);
			})
			.catch((err) => {
				console.error('Error al copiar al portapapeles:', err);
			});
	};

	return (
		<>
			<Dialog open={open} onClose={onClose} aria-labelledby='form-dialog-title'>
				<DialogTitle id='form-dialog-title'>
					{user ? 'Editar Usuario' : 'Añadir Usuario'}
				</DialogTitle>
				<DialogContent dividers style={{ minHeight: '8rem' }}>
					<TextField
						autoFocus
						margin='dense'
						id='user'
						name='user'
						label='Nombre de Usuario'
						type='text'
						fullWidth
						value={formData.user}
						onChange={handleChange}
						error={!!errors.user}
						helperText={errors.user}
					/>
					<TextField
						margin='dense'
						id='email'
						name='email'
						label='Email'
						type='email'
						fullWidth
						value={formData.email}
						onChange={handleChange}
						error={!!errors.email}
						helperText={errors.email}
					/>
					{/*<FormControl className={classes.formControl}>*/}
					{/*  <InputLabel id="equipo-label">Equipo</InputLabel>*/}
					{/*  <Select*/}
					{/*    labelId="equipo-label"*/}
					{/*    id="equipo"*/}
					{/*    name="equipo"*/}
					{/*    value={formData.equipo}*/}
					{/*    onChange={handleChange}*/}
					{/*    disabled={!currentUserConnection.user?.admin && formData.id !== ''}*/}
					{/*  >*/}
					{/*    <MenuItem value="PERFUMERIA" disabled={currentUserConnection.user.equipo !== 'PERFUMERIA'}>PERFUMERIA</MenuItem>*/}
					{/*    <MenuItem value="COMPLEMENTOS" disabled={currentUserConnection.user.equipo !== 'COMPLEMENTOS'}>COMPLEMENTOS</MenuItem>*/}
					{/*  </Select>*/}
					{/*</FormControl>*/}
					<FormControlLabel
						control={
							<Checkbox
								checked={formData.admin}
								onChange={handleCheckboxChange}
								name='admin'
								color='primary'
							/>
						}
						label='Administrador'
					/>
				</DialogContent>
				<DialogActions>
					<Box
						display='flex'
						justifyContent='space-between'
						width='100%'
						px={1}>
						<Box display='flex' justifyContent='space-between'>
							{user && (
								<>
									<DialogoConfirmacion
										title='Eliminar Usuario'
										textButtonOpen='Eliminar'
										buttonProps={{
											color: 'secondary',
											variant: 'outlined',
										}}
										buttonConfirmarProps={{
											color: 'secondary',
											variant: 'contained',
										}}
										textButtonConfirmar={
											user.admin ? 'Eliminar ADMINISTRADOR' : 'Eliminar'
										}
										textButtonCancelar='Cancelar'
										handleConfirmar={() => {
											onDelete(user);
											onClose();
										}}>
										<Alert severity='warning' icon={<PersonIcon />}>
											<AlertTitle>{user.user}</AlertTitle>
											¿Estás seguro de que deseas eliminar al usuario?
										</Alert>
										{/* eslint-disable-next-line */}
										{user.admin == 1 && (
											<Alert severity='error' style={{ marginTop: '1rem' }}>
												<AlertTitle>Usuario Administrador</AlertTitle>
												Este usuario es un administrador del sistema.
											</Alert>
										)}
									</DialogoConfirmacion>
									<DialogoConfirmacion
										title='Reset Password'
										textButtonOpen='RESET PASSWORD'
										buttonProps={{
											color: 'primary',
											variant: 'outlined',
											style: { marginLeft: '0.5rem' },
										}}
										buttonConfirmarProps={{
											color: 'primary',
											variant: 'contained',
										}}
										textButtonConfirmar='Confirmar Reset'
										textButtonCancelar='Cancelar'
										handleConfirmar={() => handleResetPassword(user.id)}>
										<Alert severity='warning'>
											<AlertTitle>Reset Password - {user.user}</AlertTitle>
											¿Estás seguro de que deseas resetear la contraseña de este
											usuario?
										</Alert>
									</DialogoConfirmacion>
								</>
							)}
						</Box>
						<Box>
							<Button
								onClick={onClose}
								variant={'outlined'}
								style={{ marginRight: '0.5rem' }}>
								Cancelar
							</Button>
							<Button
								onClick={handleSubmit}
								color={'primary'}
								variant={'contained'}>
								Guardar
							</Button>
						</Box>
					</Box>
				</DialogActions>
			</Dialog>

			<Snackbar
				open={openSnackbar}
				autoHideDuration={15000}
				onClose={handleCloseSnackbar}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
				<Alert onClose={handleCloseSnackbar} severity='success'>
					<AlertTitle>Contraseña restablecida</AlertTitle>
					<div>
						La nueva contraseña para <strong>{user?.user}</strong> es:
					</div>
					<Box
						mt={1}
						p={1.5}
						border={1}
						borderColor='primary.main'
						borderRadius='borderRadius'
						bgcolor='background.paper'
						display='flex'
						justifyContent='space-between'
						alignItems='center'>
						<Box
							flex={1}
							fontWeight='fontWeightBold'
							fontSize='h6.fontSize'
							letterSpacing={1}
							style={{
								userSelect: 'all',
								cursor: 'text',
								textAlign: 'center',
							}}>
							{newPassword}
						</Box>
						<Tooltip
							title={copySuccess ? '¡Copiado!' : 'Copiar al portapapeles'}>
							<IconButton
								size='small'
								color={copySuccess ? 'secondary' : 'primary'}
								onClick={copyToClipboard}
								style={{ marginLeft: 8 }}>
								<FileCopyIcon fontSize='small' />
							</IconButton>
						</Tooltip>
					</Box>
					<Box mt={1} fontSize='caption.fontSize' color='text.secondary'>
						Esta contraseña solo se mostrará una vez. Haga clic en el icono para
						copiar o seleccione el texto.
					</Box>
				</Alert>
			</Snackbar>
		</>
	);
}
